"use client";

import React from "react";
import { TableCell, TableRow } from "./ui/table";
import { Ticket, MessageSquareText, Contact, User } from "lucide-react";
import { transactionCategoryStyles } from "@/constants";
import { cn } from "@/lib/utils";
import Link from "next/link";
import ReviewPopover from "./ReviewPopover";

const CategoryBadge = ({ category, label }: CategoryBadgeProps) => {
  const { borderColor, backgroundColor, textColor, chipBackgroundColor } =
    transactionCategoryStyles[
      category as keyof typeof transactionCategoryStyles
    ] || transactionCategoryStyles.default;

  return (
    <div className={cn("category-badge", borderColor, chipBackgroundColor)}>
      <div className={cn("size-2 rounded-full", backgroundColor)} />
      <p className={cn("text-[12px] font-medium", textColor)}>{label}</p>
    </div>
  );
};

const TicketRow = ({
  ticket,
  displayAll
}: {
  ticket: Ticket;
  displayAll:boolean;
}) => {

  //to be removed
  const isDebit = true; //= t.type === 'debit';

  return (
    <TableRow
      key={ticket.booking_id}
      className={`${
        !isDebit ? "bg-[#FFFBFA]" : "bg-[#F6FEF9]"
      } !over:bg-none !border-b-DEFAULT`}
    >
      <TableCell className="max-w-[250px] pl-2 pr-4">
        <div className="flex flex-col items-center gap-3">
          <h1 className="text-14 truncate font-semibold text-[#344054]">
            {(new Date(ticket.creation_datetime)).toLocaleDateString('fr-FR')}  <br />
            <span className="text-12 text-[#7B8B9A] font-medium ">{(new Date(ticket.creation_datetime)).toLocaleTimeString('fr-FR')}</span>
          </h1>
        </div>
      </TableCell>

      <TableCell className="max-w-[250px] pl-2 pr-4">
        <div className="flex flex-col items-center gap-1">
          <h1 className="text-14 truncate font-semibold text-[#344054]">
            {ticket.booking_reference}
          </h1>
          
        </div>
      </TableCell>

      <TableCell className="max-w-[250px] pl-2 pr-4">
        <div className="flex flex-col items-center gap-1 text-wrap">
          <h1 className="text-14  font-semibold text-[#344054]">
            {ticket.event_name}
          </h1>
          
        </div>
      </TableCell>

      <TableCell className="pl-2 pr-4">
        <div className="flex flex-col">
            <div className="flex items-center gap-2 mt-1">
              <User className="h-3 w-3 text-current fill-white" />
              <p className="text-md"> {ticket.booking_first_name || ""} {ticket.booking_last_name || ""}</p>
            </div>
            {ticket.booking_client_comment && (
            <h1 className="text-10 text-[#7B8B9A] font-medium ">{ticket.booking_client_comment}</h1>)}
        </div>
      </TableCell>

      <TableCell className="min-w-32 pl-2 pr-4">
        <div>
        {ticket.booking_status ===  "NOT_PAID" ? (
           <Link target="_blank" href={`https://labelleconciergerie.com/bookings/${ticket.booking_id}`} className={cn("text-[12px] font-bold", "text-[#027A48]")}>
          <CategoryBadge
            category="ERROR"
            label="Non payé - cliquez pour payer"
          /></Link>): (ticket.booking_status ===  "SUCCESS") ? (
            <div className={cn("category-badge", "border-[#12B76A]", "bg-[#ECFDF3]")}>
              <Ticket className="h-3 w-3 text-current fill-white" />
              <Link target="_blank" href={`https://labelleconciergerie.com/bookings/${ticket.booking_id}`} className={cn("text-[12px] font-bold", "text-[#027A48]")}>Cliquez pour voir les tickets</Link>
            </div>
          ) :(ticket.booking_status ===  "WORK_IN_PROGRESS") ? (
            <Link target="_blank" href={`https://labelleconciergerie.com/bookings/${ticket.booking_id}`} className={cn("text-[12px] font-bold", "text-[#027A48]")}><CategoryBadge
            category=" SUCCESS"
            label="En cours de préparation"/></Link>
          ) : (
            <CategoryBadge
            category="ERROR"
            label="Une erreur est survenue"
          />)}

        </div>
      </TableCell>

      <TableCell className="min-w-32 pl-2 pr-4">
       <ReviewPopover rating={0} booking_id={ticket.booking_id}/>
      </TableCell>

      {displayAll && (
        <TableCell className="pl-2 pr-4">
          <div className="flex flex-col items-center gap-1">
            <h1 className="text-14 truncate font-semibold text-[#344054]">
              {ticket.booking_commission ? `${ticket.booking_commission.toFixed(2)} €` : ""}
            </h1>
          </div>
        </TableCell>
      )}
      
    </TableRow>
  );
};

export default TicketRow;
